import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { executePasswordReset } from "../../api/authApi";
import { LOGIN_PATH } from "../../config/publicRoutes";
import { i18_TRANSLATION } from "../../i18nReferences";
import LoginContainer from "./LoginContainer";
import ResetPasswordView from "./ResetPasswordView";

/**
 * Page behind the link in the reset mail: `/reset-password?token=...`. Opening it sends nothing, so mail
 * scanners that open links are harmless; only the submit sends `{ token, newPassword }`.
 */
const ResetPasswordContainer = () => {
    const { t } = useTranslation([i18_TRANSLATION]);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const resetMutation = useMutation({
        mutationFn: ({ newPassword }) => executePasswordReset({ token, newPassword }),
    });

    return (
        <LoginContainer maxWidth="sm">
            <ResetPasswordView
                t={t}
                onSubmit={({ newPassword }) => token && resetMutation.mutate({ newPassword })}
                isSubmitDisabled={resetMutation.isPending || !token}
                isSuccess={resetMutation.isSuccess}
                // Without a token in the link there is nothing to send.
                isFailed={!token || resetMutation.isError}
                onBackToLogin={() => navigate(LOGIN_PATH)}
            />
        </LoginContainer>
    );
};

export default ResetPasswordContainer;
